export const ListQueryKey = 'bankcards';
export const DetailQueryKey = 'bankcard';

export const Urls = {
  selectUrl: '/bankcard/list',
  updateUrl: '/bankcard/update',
  deleteUrl: '/bankcard/delete',
  createUrl: '/bankcard/create',
  detailUrl: '/bankcard/detail',
};
